<template>
    <div class="form-home">
        <div class="form-title">
            <img
                class="logo"
                src="@/assets/svg/home/logo.svg"
                alt="商城Logo"
                @click="goHome"
            />
        </div>
        <router-view v-slot="{ Component }" class="form-content">
            <component :is="Component" />
        </router-view>

        <div class="form-footer display-flex">
            <p>@2021-2025 上海感算电子科技有限公司 版权所有</p>
            <el-divider direction="vertical" style="margin: 0 16px 0 15px" />
            <p>备案号：沪ICP备2021016815号-3</p>
            <el-divider direction="vertical" style="margin: 0 16px 0 13px" />
            <p class="private" @click="getPrivateApi('2533592194358509568')">服务协议</p>
            <el-divider direction="vertical" style="margin: 0 16px 0" />
            <p class="private" @click="getPrivateApi('2533591881094332416')">隐私政策</p>
            <el-divider direction="vertical" style="margin: 0 16px 0" />
            <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502006803"
            >
                <img src="@/assets/images/ProHome/beian.png" alt="公网安备图" />
                沪公网安备 31010502006803号</a
            >
            <el-divider direction="vertical" style="margin: 0 16px 0" />
            <a
                href="https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020230315110956000010218886-SAIC_SHOW_310000-20230621164604396851&signData=MEUCICEIlChnlj05CErx6w9gEN8LglCrU2qJ3r/fjnbQjXFJAiEAxK5bkLTVpR3SLzCLu4eGFLj5el0rr8DRfMGSXqaRG9U="
                target="_blank"
            >
                <img
                    src="@/assets/images/ProHome/supervisor.png"
                    alt="工商网监"
                />
                工商网监
            </a>
        </div>
    </div>
    <ZDialog
        :dialog-object="dialogObjDelDef"
        @dialogClose="dialogCloseDef"
        class="private-dialog"
    >
        <div v-html="privates.content" class="private"></div>
    </ZDialog>
</template>
<script lang="ts">
import Breadcrumb from '@/components/ProShop/breadcrumb.vue';
import {
    reactive,
    toRefs,
    defineComponent,
    getCurrentInstance,
    onBeforeMount,
    ref,
} from 'vue';
import { useRoute, RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/store/User';
import { getPrivate } from '@/api/PcModule/home';
import ZDialog from '@/components/ZDialog.vue';
export default defineComponent({
    name: 'Form',
    components: {
        ZDialog,
    },
    setup() {
        const { proxy }: any = getCurrentInstance();
        let route = useRoute();
        const store = useUserStore();
        const data = reactive({});
        const refData = toRefs(data);
        const privates = ref('');
        const dialogObjDelDef = reactive({
            dialogVisible: false,
            title: privates.value.title,
            width: '916px',
            isFooter: false, // 是否显示按钮
        });
        onBeforeMount(() => {});

        const goHome = () => {
            location.replace(import.meta.env.VITE_SEO_HOST);
        };
        const getPrivateApi = async (id) => {
            let data = await getPrivate(id);
            if (data) {
                privates.value = data;
                dialogObjDelDef.dialogVisible = true;
                dialogObjDelDef.title = privates.value.title;
            }
        };
        // 关闭弹窗
        const dialogCloseDef = () => {
            dialogObjDelDef.dialogVisible = false;
        };
        return {
            ...refData,
            route,
            goHome,
            getPrivateApi,
            privates,
            dialogObjDelDef,
            dialogCloseDef,
        };
    },
});
</script>
<style lang="scss">
.form-home {
    background: #F0F6FC;
    min-height: 100vh;
    .form-title {
        width: 1200px;
        padding: 20px 0 23px;
        margin: 0 auto;
        .logo {
            width: 153px;
            height: 40px;
            cursor: pointer;
        }
    }
}
.form-content{
    width: 1200px;
    margin: 0 auto;
    border-radius: 10px;
background: #FFF;
padding: 24px 140px 34px;
box-sizing: border-box;
}
.form-footer {
    width: 1200px;
    margin: 0 auto;
    justify-content: center;
    padding: 20px 0;
    p {
        font-size: 13px;
        line-height: 140%;
        color: #333333;
    }

    a {
        font-size: 13px;
        color: #333333;
        line-height: 140%;
        display: flex;
        align-items: center;
        img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }
    }

    .private {
        color: #333333;
        cursor: pointer;
    }
    .el-divider{
        border-color: #333 !important;
    }
}

.form-popover {
    height: 26px;
    padding: 4px 10px !important;

    .attention-tips {
        display: flex;
        font-size: 12px;

        img {
            margin-top: -2px;
            margin-right: 4px;
        }
    }

    .el-popper__arrow:before {
        right: 80px !important;
    }
}

</style>
